import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { reportCalculationsError } from './calculationsErrorHandling'

class CalculationsErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, errorInfo) {
    reportCalculationsError(this.props.label, error, {
      componentStack: errorInfo?.componentStack
    })
  }

  render() {
    if (this.state.error) {
      return (
        <div
          data-test="calculations-section-error"
          style={{
            padding: '16px',
            margin: '12px 0',
            border: '1px solid rgba(216, 30, 5, 0.35)',
            borderRadius: '8px',
            background: 'rgba(216, 30, 5, 0.06)',
            color: '#202020',
            fontSize: '14px',
            lineHeight: '1.5'
          }}
        >
          <FormattedMessage id="calculationsSectionError" />
        </div>
      )
    }

    return this.props.children
  }
}

CalculationsErrorBoundary.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default CalculationsErrorBoundary
